import styled from 'styled-components';
import { forceBreakTextCss } from '../styles';
export const Container = styled.div ``;
export const ImageSectionWrapper = styled.div `
    padding-top: 32px;
    &.pb {
        padding-bottom: 32px;
    }
`;
export const ImageSection = styled.div `
    position: relative;
    padding-bottom: 75%; // 4:3
`;
export const Image = styled.div `
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-image: url(${(props) => props.image});
`;
export const TextContent = styled.div `
    ${forceBreakTextCss};
    display: inline-block;
    white-space: pre-line;
    h2.mt,
    p.mt {
        margin-top: 16px;
    }
`;
